import React from 'react'
import { SVGIconProps } from '../types'
const SvgSignalWifi3Bar = ({ size = 16, ...props }: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="currentColor"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h16v16H0z" />
      <path
        fill="#233745"
        fillRule="nonzero"
        d="M7.991 14.213.17 4.471C.47 4.24 3.484 1.778 8 1.778s7.529 2.462 7.831 2.693l-2.253 2.806.004.003-5.573 6.933-.009.01v-.01z"
      />
    </g>
  </svg>
)
export default SvgSignalWifi3Bar
